import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-document-viewer',
  standalone: true,
  imports: [ MatDialogModule,
    MatButtonModule,CommonModule],
  templateUrl: './document-viewer.component.html',
  styleUrl: './document-viewer.component.scss'
})
export class DocumentViewerComponent {
  documentBlobUrl: SafeResourceUrl | null = null;
  private readonly authService = inject(AuthService);

  constructor(
    public dialogRef: MatDialogRef<DocumentViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { documentUrl: string },
    private http: HttpClient,
    private sanitizer: DomSanitizer // Inject DomSanitizer
  ) {
    this.fetchDocument();
  }

  fetchDocument() {
    const token = this.authService.getToken(); 

    const headers = new HttpHeaders({ 'Authorization': `${token}` }); // Ensure token is passed

    this.http.get(this.data.documentUrl, { headers, responseType: 'blob' }).subscribe(response => {
      const mimeType = response.type;
      
      // Allowed MIME types
      const allowedFileTypes = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedFileTypes.includes(mimeType)) {
        return;
      }

      // Convert to blob and create a safe URL
      const blob = new Blob([response], { type: mimeType });
      const url = URL.createObjectURL(blob);
      this.documentBlobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url); // Sanitize URL

    }, error => {
      console.error("Error fetching document:", error);
    });
  }


  closeDialog(): void {
    this.dialogRef.close();
  }

}
